import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=f1a80654&functional=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=ts&"
export * from "./BaseListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports